import { isSpecialItemizerLogin } from "./itemizerRules";

export const isSlgAnaLogin = isSpecialItemizerLogin;
